import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CultureKeyType, FALLBACK_CULTURE } from '@constants/app.constants';
import { BoardingPassRequest } from '@models/requests/boarding-pass-request.model';
import { ApiResponse } from '@models/responses/api-response.model';
import {
  AppleBoardingPassResult,
  GoogleBoardingPassResult,
} from '@models/responses/boarding-pass-result.model';
import { EnvironmentService } from '@services/environment-service/environment.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WalletService {
  static readonly CONTROLLER_ROOT = 'v1/wallet';
  static readonly GOOGLE_ROOT = '/google';
  static readonly APPLE_ROOT = '/apple';

  constructor(private httpClient: HttpClient) {}

  createGoogleBoardingPass(
    request: BoardingPassRequest,
    cultureCode: CultureKeyType = FALLBACK_CULTURE,
  ): Observable<ApiResponse<GoogleBoardingPassResult>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${WalletService.CONTROLLER_ROOT}/${cultureCode}${WalletService.GOOGLE_ROOT}/boardingpass`;
    return this.httpClient.post<ApiResponse<GoogleBoardingPassResult>>(
      endpoint,
      request,
    );
  }

  createAppleBoardingPass(
    request: BoardingPassRequest,
    cultureCode: CultureKeyType = FALLBACK_CULTURE,
  ): Observable<ApiResponse<AppleBoardingPassResult>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${WalletService.CONTROLLER_ROOT}/${cultureCode}${WalletService.APPLE_ROOT}/boardingpass`;
    return this.httpClient.post<ApiResponse<AppleBoardingPassResult>>(
      endpoint,
      request,
    );
  }

  createGoogleBoardingPasses(
    request: BoardingPassRequest[],
    cultureCode: CultureKeyType = FALLBACK_CULTURE,
  ): Observable<ApiResponse<GoogleBoardingPassResult>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${WalletService.CONTROLLER_ROOT}/${cultureCode}${WalletService.GOOGLE_ROOT}/boardingpasses`;
    return this.httpClient.post<ApiResponse<GoogleBoardingPassResult>>(
      endpoint,
      request,
    );
  }

  createAppleBoardingPasses(
    request: BoardingPassRequest[],
    cultureCode: CultureKeyType = FALLBACK_CULTURE,
  ): Observable<ApiResponse<AppleBoardingPassResult>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${WalletService.CONTROLLER_ROOT}/${cultureCode}${WalletService.APPLE_ROOT}/boardingpasses`;
    return this.httpClient.post<ApiResponse<AppleBoardingPassResult>>(
      endpoint,
      request,
    );
  }
}
